import React, { useEffect, useState } from 'react';
import './Disclaimer.css';

function Disclaimer({ theme }) {
    const KEY = 'useless_disclaimer_dismissed_v1';
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const dismissed = window.sessionStorage.getItem(KEY);
            if (!dismissed) setVisible(true);
        } catch {
            setVisible(true);
        }
    }, []);

    const dismiss = () => {
        try {
            window.sessionStorage.setItem(KEY, '1');
        } catch { }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className={`tos-modal-overlay ${theme}`} onClick={dismiss}>
            <div className="tos-modal" onClick={(e) => e.stopPropagation()}>
                <div className="tos-modal-header">
                    <h2>Welcome — Important Disclaimer</h2>
                </div>
                <div className="tos-modal-content">
                    <p>
                        Heyyyy!!!! Explore my stupid products, system designs, services, and more!
                        <br></br>
                        <i>NOTE: Website preserves resources by putting the servers to sleep, so it may take upto a minute to load all features(or refresh page)</i>
                    </p>

                    <div style={{ marginTop: 20, textAlign: 'right' }}>
                        <button className="refresh-btn" onClick={dismiss}>I Understand</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Disclaimer;
